import { formatBgn, formatEuro } from "features/utils";
import React, { memo } from "react";
import styled from "styled-components";
import { colors } from "theme/Theme";
import { SHOW_BGN_PRICES } from "config";

interface InstallationPriceProps {
  installationPrice: any;
  installationPriceEur?: any;
  powerBtu: string;
  type: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectInstallation: React.FC<InstallationPriceProps> = ({
  installationPrice,
  installationPriceEur,
  powerBtu,
  type,
  onChange,
}) => {
  return (
    <Select name="installation" id="installation" onChange={onChange}>
      <option value="free">Без монтаж</option>
      <option value="paid">{`С включен монтаж (+${formatEuro(
        installationPrice,
        installationPriceEur
      )} €${
        SHOW_BGN_PRICES ? ` / ${formatBgn(installationPrice)} лв.` : ""
      })`}</option>
    </Select>
  );
};

const Select = styled.select`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${colors.gray};
  font-size: 16px;
`;
export default memo(SelectInstallation);
